// extracted by css-extract-rspack-plugin
export default {"dialog":"dialog-r8rEie","body":"body-s6c3Rl","content":"content-FRTRhe","controls":"controls-GIfKk9","chart":"chart-GEFLwQ","empty":"empty-fL8otJ"};